// extracted by mini-css-extract-plugin
export default {"order":"Order_order__0+9b9","container":"Order_container__EPIks","content":"Order_content__ZKloX","left":"Order_left__B4vl-","right":"Order_right__zTlpg","own":"Order_own__EB4W6"};